var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "business-intro",
    attrs: {
      "color": "primary",
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "business-intro__text"
  }, [_c('v-card-subtitle', {
    staticClass: "pt-md-40 pb-md-24"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/business/quotes.svg",
      "max-width": "24",
      "alt": ""
    }
  })], 1), _vm.title ? _c('v-card-title', {
    staticClass: "justify-center pt-0 pb-md-24 white--text line-height-14"
  }, [_c('div', {
    staticClass: "client-title font-size-md-36"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]) : _vm._e(), _c('v-card-text', {
    staticClass: "text-center white--text pb-md-40"
  }, [_c('p', {
    staticClass: "client-title--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.texts)
    }
  })])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }